import React from 'react';
import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';
import { MediaCard as _MediaCard } from 'src/apps/Onboarding/Bienvenue/MediaCard';
import { Loader as LoaderComponent } from 'src/components';

const cardsPerRow = 4;
const cardWidth = 12;
const cardMargin = 1;
const pageWidth = cardsPerRow * cardWidth + cardsPerRow * cardMargin * 2;

export const BienvenueContainer = styled.div`
  background: ${({ theme }) => theme.co.neutral99};
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100dvh;
  width: 100%;
`;

interface MotionedSectionContainerProps {
  children: React.ReactNode;
  className?: string;
}

export const MotionedSectionContainer = ({
  children,
  className,
}: MotionedSectionContainerProps) => (
  <motion.div
    className={className}
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
  >
    {children}
  </motion.div>
);

export const SectionContainer = styled(MotionedSectionContainer)`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: ${pageWidth}rem;
  width: 100%;
`;

export const CardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0 auto;
  max-width: ${pageWidth}rem;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.sz.xl}) {
    justify-content: flex-start;
  }
`;

export const Background = styled.div(
  ({ theme }) => css`
    background: ${theme.co.neutral99};
    min-height: calc(100dvh - ${theme.sz.s16});
  `,
);

export const ErrorContainer = styled.div(
  ({ theme }) => css`
    background: ${theme.co.error60};
    border-radius: ${theme.bo.medium};
    padding: ${theme.sz.s4} ${theme.sz.s8};
    font-size: ${theme.DEPRECATED_ty.mediumLarge};
    color: ${theme.co.neutral99};
    text-align: center;
    display: flex;
    justify-content: center;
    margin: 0 auto;
  `,
);

export const MediaCard = styled(_MediaCard)`
  margin: ${({ theme }) => theme.sz.s2};

  @media (min-width: ${({ theme }) => theme.sz.xl}) {
    margin: ${cardMargin}rem;
  }
`;

export const ButtonWrapper = styled.div(
  () => css`
    display: flex;
    justify-content: flex-end;
  `,
);

export const Loader = styled(LoaderComponent)(
  ({ theme }) => css`
    max-height: ${theme.sz.s40};
    margin: auto;
    display: block;
  `,
);
